export enum Role {
  SUPER_ADMIN = 'superadmin',
  ADMIN = 'admin',
  AMBASSADOR = 'ambassador',
  ADMITTED_GRADUATE_STUDENT = 'admitted_graduate_student',
  STUDENT = 'student',
  PROSPECTIVE_STUDENT = 'prospective_student',
  GUEST_STUDENT = 'guest_student',
  GUEST_LANG_PARTNER = 'guest_language_partner',
  FAMILY = 'family',
  // ADDITIONAL ROLES as STUDENT
  UNDERGRAD_STUDENT = 'undergrad_student',
  ADMITTED_UNDERGRAD_STUDENT = 'admitted_undergrad_student',
  GRADUATE_STUDENT = 'graduate_student',
  IEP_STUDENT = 'iep_student',
  EXCHANGE_STUDENT = 'exchange_student',
  SCHOLARS = 'scholars',
  ALUMNI = 'alumni',
  // This does not give student any additional permissions - but gives them a staff badge
  INSTITUTIONAL_STAFF = 'institutional_staff',
  FACULTY = 'faculty',
}

export const SUPER_ROLES = [Role.SUPER_ADMIN];
export const STAFF_ROLES = [Role.ADMIN, Role.SUPER_ADMIN];
export const ADMIN_ROLES = [Role.ADMIN];

export const STUDENT_ROLES = [
  Role.STUDENT,
  Role.AMBASSADOR,
  Role.FAMILY,
  Role.GUEST_LANG_PARTNER,
  Role.GUEST_STUDENT,
  Role.UNDERGRAD_STUDENT,
  Role.GRADUATE_STUDENT,
  Role.IEP_STUDENT,
  Role.EXCHANGE_STUDENT,
  Role.SCHOLARS,
  Role.ALUMNI,
  Role.ADMITTED_UNDERGRAD_STUDENT,
  Role.ADMITTED_GRADUATE_STUDENT,
  Role.INSTITUTIONAL_STAFF,
  Role.FACULTY,
];

export const SELF_ASSIGNABLE_ADDITIONAL_ROLES = [
  Role.UNDERGRAD_STUDENT,
  Role.GRADUATE_STUDENT,
  Role.IEP_STUDENT,
  Role.EXCHANGE_STUDENT,
  Role.SCHOLARS,
  Role.ALUMNI,
  Role.ADMITTED_UNDERGRAD_STUDENT,
  Role.ADMITTED_GRADUATE_STUDENT,
  Role.INSTITUTIONAL_STAFF,
  Role.FACULTY,
];

export const PROSPECTIVE_STUDENT_ROLES = [Role.PROSPECTIVE_STUDENT];

export const USER_ROLES = [
  Role.STUDENT,
  Role.AMBASSADOR,
  Role.FAMILY,
  Role.GUEST_LANG_PARTNER,
  Role.GUEST_STUDENT,
  Role.UNDERGRAD_STUDENT,
  Role.PROSPECTIVE_STUDENT,
  Role.GRADUATE_STUDENT,
  Role.IEP_STUDENT,
  Role.EXCHANGE_STUDENT,
  Role.SCHOLARS,
  Role.ALUMNI,
  Role.ADMITTED_UNDERGRAD_STUDENT,
  Role.ADMITTED_GRADUATE_STUDENT,
  Role.INSTITUTIONAL_STAFF,
  Role.FACULTY,
];

export const ALL_ROLES = [...USER_ROLES, ...STAFF_ROLES];
